module.exports = __webpack_public_path__ + "static/media/handbags_mipel_desktop.d8e41bdd.jpg";